export default "__VITE_ASSET__DxmQIyDo__"